import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { TextKey } from '@mews-distributor/common';

import { isAppOpened } from '../../modules/app/selectors';
import { localizeText } from '../../modules/globalization/selectors';
import { getLocalizedHotelName } from '../../selectors/withContainerUse';
import { ApplicationState } from '../../types';

class BaseDocumentTitle extends PureComponent {
    setIframeTitle = (title: string) => {
        if (window.frameElement) {
            (window.frameElement as HTMLIFrameElement).title = title;
        }
    };
    componentDidUpdate() {
        // @ts-expect-error $TSFixMeError: Property 'appOpen' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
        const { appOpen, hotelName, localizedTitle, contextWindow } = this.props;
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (appOpen) {
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (!this.originalTitle) {
                this.originalTitle = contextWindow.document.title;
                this.setIframeTitle(contextWindow.document.title);
            }

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (hotelName && hotelName.length > 0) {
                contextWindow.document.title = `${hotelName} - ${localizedTitle}`;
                this.setIframeTitle(`${hotelName} - ${localizedTitle}`);
            } else {
                contextWindow.document.title = localizedTitle;
                this.setIframeTitle(localizedTitle);
            }
        }

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!appOpen && this.originalTitle) {
            contextWindow.document.title = this.originalTitle;
            this.originalTitle = null;
        }
    }

    originalTitle = null;

    render() {
        return null;
    }
}

export const DocumentTitle = connect((state: ApplicationState) => ({
    appOpen: isAppOpened(state),
    hotelName: getLocalizedHotelName(state),
    localizedTitle: localizeText(TextKey.NewBooking)(state),
}))(BaseDocumentTitle);
